import styled from 'styled-components'
import { MitraCard } from '../../commonStyle/index.style'

export const RadioInputCardStyle = styled(MitraCard)`
  width: auto;
  padding: 0;
  margin-top: 0px;
  background-color: ${(props) =>
    props.disabled ? props.theme.saturatedGrey : props.theme.white};
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.errorDark} !important` : 'none'};

  .radio-border-btm {
    border-bottom: 1px solid ${(props) => props.theme.Gray90};
  }

  .vertical-group-pad-top {
    padding: 10px;
  }
`

export const RadioErrorStyle = styled.span`
  color: ${(props) => props.theme.errorDark};
  text-align: left;
  font-size: 0.8em;
  margin-top: -12px;
  margin-bottom: 4px;
`
